var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import JsonExportButton from '~/js/components/atomos/JsonExportButton.vue';
var SuperChatEvents = /** @class */ (function (_super) {
    __extends(SuperChatEvents, _super);
    function SuperChatEvents() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.json = null;
        _this.result = [];
        return _this;
    }
    Object.defineProperty(SuperChatEvents.prototype, "status", {
        get: function () {
            if (this.json == null)
                return 'in progress';
            if (this.json.result === undefined)
                return 'forbidden';
            return 'success';
        },
        enumerable: false,
        configurable: true
    });
    SuperChatEvents.prototype.created = function () {
        var _this = this;
        // https://developers.google.com/youtube/v3/live/docs/superChatEvents/list
        // hl: https://developers.google.com/youtube/v3/docs/i18nLan@miguages/list
        gapi.client.load('youtube', 'v3', function () {
            var options = {
                part: 'snippet,id',
                hl: 'ja',
                maxResults: 50
            };
            var request = gapi.client.youtube.superChatEvents.list(options);
            request.execute(function (response) {
                console.log('==== SuperChatEvents ====');
                console.log(response);
                console.log('==== /SuperChatEvents ====');
                _this.json = {
                    request: 'gapi.client.youtube.superChatEvents.list',
                    options: options,
                    result: response.result
                };
                _this.result = response.result != null ? response.result.items || [] : [];
            });
        });
    };
    SuperChatEvents = __decorate([
        Component({
            components: { JsonExportButton: JsonExportButton }
        })
    ], SuperChatEvents);
    return SuperChatEvents;
}(Vue));
export default SuperChatEvents;
